import {
  BillingCurrency,
  TransactionCurrency,
} from '@contracts/payment/Currency';
import * as yup from 'yup';

export class CurrencyField {
  public static fieldName = 'currency' as const;
  public static validator = yup
    .string()
    .oneOf(Object.values(TransactionCurrency))
    .required();
}

export class BillingCurrencyField {
  public static fieldName = 'currency' as const;
  public static validator = yup
    .string()
    .oneOf(Object.values(BillingCurrency))
    .required();
}
